const DEFAULT_QUERY_LABEL = 'All lessons'
const PROGRESS_SELECTOR = '[data-controller~="lesson-search-progress"]'
const PROGRESS_START_EVENT = 'lesson-search-progress:start'
const PROGRESS_STOP_EVENT = 'lesson-search-progress:stop'

function progressElements(root) {
  if (!root) return []

  const descendants = [...root.querySelectorAll(PROGRESS_SELECTOR)]
  return root.matches?.(PROGRESS_SELECTOR) ? [root, ...descendants] : descendants
}

function dispatchProgressEvent(root, eventName) {
  progressElements(root).forEach((element) => {
    element.dispatchEvent(new CustomEvent(eventName))
  })
}

export function beginLessonSearchLoadingProgress(root) {
  dispatchProgressEvent(root, PROGRESS_START_EVENT)
}

export function endLessonSearchLoadingProgress(root) {
  dispatchProgressEvent(root, PROGRESS_STOP_EVENT)
}

export function updateLessonSearchLoadingQuery(query) {
  const label = query?.trim() || DEFAULT_QUERY_LABEL

  document.querySelectorAll('[data-lesson-search-loading-query]').forEach((element) => {
    element.textContent = label
  })
}

export function beginLessonResultsLoading(query) {
  updateLessonSearchLoadingQuery(query)

  const results = document.getElementById('search_results')
  results?.classList.add('is-search-pending')
  results?.setAttribute('aria-busy', 'true')
  if (results) beginLessonSearchLoadingProgress(results.parentElement)
}

export function endLessonResultsLoading() {
  const results = document.getElementById('search_results')
  results?.classList.remove('is-search-pending')
  results?.removeAttribute('aria-busy')
  if (results) endLessonSearchLoadingProgress(results.parentElement)
}
